import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { watch } from "vue";
import useStore from "@src/stores/store";

function applyStatusBarStyle(darkMode: boolean) {
    StatusBar.setBackgroundColor({ color: darkMode ? "#1f2937" : "#ffffff" });
    StatusBar.setStyle({ style: darkMode ? Style.Dark : Style.Light });
}

export async function initStatusBar() {
    if (!Capacitor.isNativePlatform()) return;

    // Sem efeito no Android 15+ (edge-to-edge obrigatório — ver MainActivity.java
    // e o padding de safe-area em App.vue), mas ainda funciona no iOS.
    await StatusBar.setOverlaysWebView({ overlay: false });

    const store = useStore();

    // O ícone/texto da status bar acompanha o tema claro/escuro do app. A cor de
    // fundo em si só é controlável no iOS (Android 15+ ignora setBackgroundColor);
    // no Android quem "colore" a área da status bar é o próprio fundo da página,
    // via o padding de safe-area já aplicado em App.vue.
    watch(() => store.settings.darkMode, applyStatusBarStyle, { immediate: true });
}

// No iOS, o plugin nativo reaplica o estilo estático de capacitor.config.ts
// (LIGHT) toda vez que a view reaparece (viewDidAppear) — o que acontece ao
// fechar a câmera/seletor de fotos nativo, não só ao sair/voltar do app.
// Isso reverte a status bar para o claro fixo por baixo do watch() acima, já
// que o valor de darkMode em si não muda. Chamar isso nos mesmos pontos em
// que já detectamos o app voltando ao primeiro plano reforça o estilo certo.
export function reapplyStatusBarStyle() {
    if (!Capacitor.isNativePlatform()) return;
    const store = useStore();
    applyStatusBarStyle(store.settings.darkMode);
}
